package dev.lingvo.shared.screenshots.templates

import dev.lingvo.shared.screenshots.doc.Anchor
import dev.lingvo.shared.screenshots.doc.FrameFinish
import dev.lingvo.shared.screenshots.doc.SceneKind
import dev.lingvo.shared.screenshots.doc.SceneSpec

/** A low glow anchors GRAPHITE against a dark field without ornamental gold. Play stays frameless. */
object Night : Template by StyledTemplate("night", "Night", TemplateCategory.DARK, "Inter", 600, .090, .042, 1.10, 0.0, FrameFinish.GRAPHITE)

/** The device crosses a hard field boundary to create depth and a shared grid. Play stays frameless. */
object Split : Template by StyledTemplate("split", "Split", TemplateCategory.BOLD, "Inter Tight", 700, .085, .042, 1.08, -.02, FrameFinish.SILVER)

/** A continuous background and ribbon turn carousel scrolling into a connected story. Play stays frameless. */
object Panorama : Template by StyledTemplate("panorama", "Panorama", TemplateCategory.BOLD, "Inter Tight", 700, .085, .042, 1.08, -.02, FrameFinish.SILVER, SceneSpec(SceneKind.PANORAMA))

/** A large serif, quiet number and end-anchored device create magazine hierarchy. Play stays frameless. */
object Editorial : Template by StyledTemplate("editorial", "Editorial", TemplateCategory.MINIMAL, "Instrument Serif", 400, .120, .050, 1.0, -.01, FrameFinish.GRAPHITE,
    SceneSpec(SceneKind.SINGLE, captionShare = .38, deviceScale = .78, deviceAnchor = Anchor.END))

/** The original eight retain their order; the four later directions append without replacing saved identities. */
object LaunchTemplates {
    /** Stable order gives the picker a consistent sequence across clients. */
    val all: List<Template> = listOf(Aurora, Paper, Mono, Pop, Night, Split, Panorama, Editorial, Fan, Gradient, Grid, Spotlight)
}
